<template>
  <div id="user-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'UserLayout',
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped></style>
